module.exports = '<!DOCTYPE html>\n<md-icon>info_outline\n  <md-tooltip md-direction="left">{{ field.description }}</md-tooltip>\n</md-icon>\n';